import { useMap, useApiIsLoaded } from '@vis.gl/react-google-maps'
import { useEffect, useState } from 'react'
export function useMapViewport({ padding = 0 }) {
    const map = useMap()
    const [bbox, setBbox] = useState([-143, 21, -61, 52])
    const [zoom, setZoom] = useState(0)
    const apiIsLoaded = useApiIsLoaded()

    useEffect(() => {
        if (!map) return

        if (apiIsLoaded) {
            const listener = map.addListener('bounds_changed', () => {
                const bounds = map.getBounds()
                const zoom = map.getZoom()
                const projection = map.getProjection()
                if (!bounds || !zoom || !projection) return

                const sw = bounds.getSouthWest()
                const ne = bounds.getNorthEast()

                const n = ne.lat()
                const s = sw.lat()

                const w = sw.lng()
                const e = ne.lng()

                setBbox([w, s, e, n])
                setZoom(zoom)
            })

            return () => listener.remove()
        }
    }, [map])

    return { padding, bbox, zoom }
}

// function degreesPerPixel(zoomLevel) {
//     // 360° divided by the number of pixels at the zoom-level
//     return 360 / (Math.pow(2, zoomLevel) * 256)
// }
